import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export const PLAN_ORDER = ["show_day", "barn", "pro"];

/** Current barn's plan, status, features, trial/founding info. Cached 1 min. */
export function useEntitlements(enabled = true) {
  const q = useQuery({
    queryKey: ["billing-me"],
    queryFn: async () => (await api.get("/billing/me")).data,
    staleTime: 60_000,
    retry: false,
    enabled,
  });
  const ent = q.data;
  const has = (feature) => !ent || (ent.features || []).includes(feature);
  return { ...q, ent, has, readOnly: !!ent?.read_only };
}

export function planRank(plan) {
  return PLAN_ORDER.indexOf(plan);
}
